<div class="lex-xi-simple-modal__container" [ngStyle]="{ 'height.px': containerHeight }">
  <h1 class="lex-xi-simple-modal__title kxi-text-xlarge">{{ title | titlecase }}</h1>
  <div class="lex-xi-simple-modal__content" [ngStyle]="{ 'height.px': contentHeight }">
    <p class="kxi-text-normal">{{ content }}</p>
  </div>
  <div class="lex-xi-simple-modal__actions">
    @if (cancelButton) {
      <div>
        <xi-default-button
          [text]="cancelButton"
          fill="outline"
          (onClick)="onCancel()"
        ></xi-default-button>
      </div>
    }
    @if (confirmButton) {
      <div>
        <xi-default-button [text]="confirmButton" (onClick)="onConfirm()"></xi-default-button>
      </div>
    }
  </div>
</div>
